<template>
  <div class="file_upload el-form-item__content">
    <el-upload ref="upload" class="upload-demo" :action="fileUploadPath" accept=".doc,.docx,.pdf,.zip,.rar,.jpg,.png"
      :on-remove="handleUploadRemove" :on-exceed="handleExceed" :file-list="fileList" multiple :limit="3"
      :http-request="uploadSectionFile" :before-upload="beforeAvatarUpload" drag>
      <!-- <el-button size="small" type="primary" class="el-icon-upload">上传文件</el-button> -->
      <i class="el-icon-upload"></i>
  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div class="el-upload__tip" slot="tip">
        支持格式：.doc,.docx,.pdf,.zip,.rar,.jpg&nbsp;&nbsp;(请上传小于10M的文件)。</div>
    </el-upload>
  </div>
</template>

<script>
  import GlobalUtil from '@/utils/globalUtil.js';
  export default {
    data() {
      return {
        fileList: [],
        fileUploadPath: ''
      }
    },  
    
    methods: {
      uploadFiles(file, fileName) {
        GlobalUtil.getTicket().then(res => {
          if (res.data) {
            this.$axios.post(this.$url.uploadFile, file, {
              'Content-Type': 'multipart/form-data',
              'ticket': res.data

            }).then(res => {
              if (!res.msg) {
                let obj = {
                  name: fileName,
                  url: res.data.data
                }
                this.fileList.push(obj)
                this.$emit('uploadList', this.fileList)
              }
            })
          }
        });
      },
      uploadSectionFile(file) {
        var self = this;
        var formData = new FormData();
        var fileName = file.file.name;
        var suffix = fileName.substring(fileName.lastIndexOf('.') + 1);
        formData.append('suffix', suffix)
        let fileSize = file.file.size / 1024 / 1024;
        // console.log(fileSize)
        if (fileSize > 10) {
          this.$message.error('文件太大，超过10M');
          return false
        }
        formData.append('file', file.file);
        self.uploadFiles(formData, fileName)
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      handleUploadRemove(file, fileList) { //删除类似
        this.fileIdsList = [];
        this.sourceFileList = [];
        fileList.map(res => {
          if (res.response) {
            this.fileIdsList.push(res.response.data.id);
            this.sourceFileList.push({
              name: res.response.data.fileName,
              url: res.response.data.accessUrl,
              fileUrl: res.response.data.fileUrl,
              id: res.response.data.id
            });
          } else {
            this.fileIdsList.push(res.id);
            this.sourceFileList.push({
              name: res.fileName,
              url: res.accessUrl,
              fileUrl: res.fileUrl,
              id: res.id
            });
          }
        })
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 2MB!');
        }
        return isLt2M;
      }
    }
  }

</script>

<style>
  .file_upload {
    width: 485px;
  }

  .el-upload-list {
    display: block;
  }

</style>
